// Shared display fallbacks used only when the live hackathon config hasn't loaded yet.
// These are NOT authoritative: the server always computes the real entry fee, team
// bounds and any referral-adjusted price. Never use these for payment calculation.
export const FEE_DEFAULT = 200;
export const TEAM_MIN_DEFAULT = 2;
export const TEAM_MAX_DEFAULT = 6;
export const ROUNDS_DEFAULT = 2;
